import { addDays } from "date-fns";
import { useTranslation } from "react-i18next";
import { AdapterDateFns as MuiAdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import {
  DatePicker as MuiDatePicker,
  LocalizationProvider as MuiLocalizationProvider,
} from "@mui/x-date-pickers-pro";
import { getIsValidDate } from "app/shared/utils";

export const ComponentExpirationDateField = ({
  value,
  startDate,
  onChange,
  required = false,
  size = "medium",
  ...passedParams
}) => {
  const { t } = useTranslation();

  return (
    <MuiLocalizationProvider dateAdapter={MuiAdapterDateFns}>
      <MuiDatePicker
        {...passedParams}
        required={required}
        value={getIsValidDate(value)}
        onChange={(val) => {
          onChange(val);
        }}
        minDate={(startDate && addDays(new Date(startDate), 1)) || undefined}
        minDateMessage={t(
          `Commitments.commitmentComponents.create.form.fields.expirationDate.validation.minDateMessage`
        )}
        format="MM/dd/yyyy"
        slotProps={{
          textField: {
            required,
            size,
            variant: "outlined",
            fullWidth: true,
            slotProps: { htmlInput: { autoComplete: "off" } },
          },
        }}
      />
    </MuiLocalizationProvider>
  );
};
